import { render } from "./index.vue?vue&type=template&id=d04b68c0&scoped=true&bindings={}"
import script from "./new-releases.js?vue&type=script&lang=js"
export * from "./new-releases.js?vue&type=script&lang=js"

import "./new-releases.scss?vue&type=style&index=0&id=d04b68c0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-d04b68c0"

export default script